const scheduledServicesDraggableCard = {
  serialNumber: "Número de Serie: ",
  place: "Lugar: ",
  expirationDate: "Fecha de Vencimiento: ",
  service: "Servicio: ",
  company: "Compañía: "
};

export default scheduledServicesDraggableCard;
